import { Outlet } from "react-router-dom";
import { TAB_NAMES } from "src/apps/common/menu-navigation/menuNavigation";
import TabHeader from "src/apps/common/tab-header/TabHeader";
import NestedNavigation from "src/components/nested-navigation/NestedNavigation";
import useSetActiveTab from "src/hooks/useSetActiveTab";

const tabs = [
  {
    label: "Customer",
    href: "customer",
  },
  {
    label: "Order",
    href: "order",
  },
  {
    label: "Enquiry",
    href: "enquiry",
  },
];

const DataExport = () => {
  useSetActiveTab(TAB_NAMES.DATA_EXPORT);

  return (
    <div className="flex flex-col gap-5">
      <TabHeader label="Data Export" subLabel="All Data Export" />
      <div className="px-[50px] py-[34px] flex flex-col gap-10 bg-white items-start self-stretch rounded-14px border-[0.3px] border-solid border-[#B9B9B9] min-h-[calc(100vh-239px)]">
        <NestedNavigation tabs={tabs} />
        <Outlet />
      </div>
    </div>
  );
};

export default DataExport;
